import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "my-1 flex flex-wrap justify-between" }
const _hoisted_2 = { class: "lg:w-1/2 w-full" }
const _hoisted_3 = { class: "lg:w-1/2 w-full text-right" }

import TextButton from '@/components/Buttons/TextButton.vue'
    import FullButton from '@/components/Buttons/FullButton.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'TheVisaNavigation',
  setup(__props) {

    
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TextButton, {
      title: "Visa",
      link: "/visa",
      id: "visa-subnavigationTitle"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(FullButton, {
          title: "Quittungen",
          link: "/visa/receipts",
          width: "95",
          colour: "red",
          id: "visa-subnavigationButton1"
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(FullButton, {
          title: "Archiv",
          link: "/visa/archive",
          width: "95",
          colour: "red",
          id: "visa-subnavigationButton2"
        })
      ])
    ])
  ], 64))
}
}

})